import { render, staticRenderFns } from "./benefits-file-upload.vue?vue&type=template&id=1d37c08d"
import script from "./benefits-file-upload.vue?vue&type=script&lang=js"
export * from "./benefits-file-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports